<template>
  <div v-if="surveyResponse.complete">
    <h1>Survey Successfully Completed</h1>
    <survey-response :pages="surveyResponse.formatted_response.pages"></survey-response>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import SurveyResponse from '@/components/survey/Response';

  export default {
    name: 'survey-complete',

    components: { SurveyResponse },

    computed: {
      ...mapState({
        surveyResponse: state => state.survey.surveyResponse,
      }),
    },
  };
</script>
